import * as React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"

const Box = styled.div`
 width: 100%;
  .desktop-view {
    width: 100%;
    height: auto;
    display: block;
    max-height: none;
  }

  .mobile-view {
     display: none;
  }

  @media (max-width: 766px) {
    height: auto;
    padding-top: 1.2rem;
    .mobile-view {
      width: 100%;
      height: auto;
      display: block;
      max-height: none;
      margin-bottom: 90px;
    } 
    .desktop-view {
    display: none;
    }
  }
`
const Header = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding-bottom: 2rem;
  padding-right: 2rem;
  padding-left: 2rem;

.hero-overlay {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.headline {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: center;
}

.highlight-top {
  color: var(--c-blue-101);
  font-size: 2rem;
  font-weight: 800;
  padding: 0.25rem 0.75rem;
  margin-bottom: 0.2rem;
  display: inline-block;
   background: linear-gradient(90deg, #3893DF, #35FFD9, #F0FFFC);
  transform: rotate(-2deg);
  border: 6px solid #000;
  box-shadow: 6px 6px 0px #000;
}

.highlight-bottom {
  background: linear-gradient(90deg, #F0FFFC,  #35FFD9, #3893DF);
  color: var(--c-blue-101);
  font-size: 2rem;
  font-weight: 800;
  padding: 0.25rem 0.75rem;
  bottom: 0;
  margin-left: 2rem;
  margin-right: 2rem;
  display: inline-block;
  margin-top: 12px;
  transform: rotate(3deg);
  border: 6px solid #000;
  box-shadow: 6px 6px 0px #000;
}

@media (max-width: 766px) {
.highlight-top {
font-size: 1.2rem;
border: 3px solid #000 !important;
  box-shadow: 3px 3px 0px #000 !important;
}

.highlight-bottom {
font-size: 1.2rem;
border: 3px solid #000 !important;
  margin-top: 8px;
  box-shadow: 3px 3px 0px #000 !important;
}

.cta-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem !important;
}

.cta-btn {
margin-top: 20px
}

.cta-bar p {
  font-size: 1rem !important;
}
  }

.cta-bar {
  background-color: var(--c-blue-101);
  color: white;
  padding: 1rem 1.5rem;
  margin-left: 8rem;
  margin-right: 8rem;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.2rem;
  width: 100%;
}

.cta-bar p {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 400;
}

.cta-bar strong {
  font-weight: 700;
}

.cta-btn {
  background-color: var(--c-mint-100);
  color: var(--c-blue-101);
  font-weight: 700;
  padding: 0.75rem 1.25rem;
  border-radius: 999px;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.3s ease;
}

.cta-btn:hover {
  background-color: var(--c-mint-50);
}
`

const Ele = () => {
  const [userCount, setUserCount] = React.useState("500,000");

  React.useEffect(() => {
    const tenantId = "UG";
    const headers = {
      "appId": "ultima",
      "production": true,
      "tenantId": tenantId
    };

    fetch("https://bf.xn-io.com/leg/api/v1/guest/number-of-clients", { headers })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
        return response.json();
      })
      .then((data) => {
        setUserCount(data['numberOfClients']);
      })
      .catch((error) => {
        console.error("Error fetching user count:", error)
        // throw new Error(`${error}`)
      });
  }, []);

  const data = useStaticQuery(graphql`
  query {
    mobileImg: file(relativePath: { eq: "jiwekesawa-mobile.png" }) {
      childImageSharp {
        gatsbyImageData
      }
    }
    desktopImg: file(relativePath: { eq: "jiwekesawa-desktop.png" }) {
      childImageSharp {
        gatsbyImageData
      }
    }
  }
`)

  const mobileImg = data.mobileImg.childImageSharp.gatsbyImageData
  const desktopImg = data.desktopImg.childImageSharp.gatsbyImageData


  return (
    <Box>
        <GatsbyImage image={getImage(mobileImg)} alt="" className="mobile-view" />
      <Header >
        <GatsbyImage image={getImage(desktopImg)} alt="" className="desktop-view" />
        <div className="hero-overlay">
          <div className="headline">
            <span className="highlight-top">BUILD YOUR DREAM LIFE,</span>
            <span className="highlight-bottom">ONE STEP AT A TIME</span>
          </div>

          <div className="cta-bar">
            <p>JOIN <strong>OVER {userCount.toLocaleString()} PEOPLE</strong> USING XENO TO TURN THEIR <strong>SAVINGS INTO SUCCESS.</strong></p>
            <a href="https://join.myxeno.com/?country=KE" className="cta-btn">START FROM KES 500</a>
          </div>

        </div>
      </Header>

    </Box>
  )
}
export default Ele
